export default __webpack_public_path__ + "static/media/employee_template.50098bad.xlsx";